import { render, staticRenderFns } from "./edit_transfer.vue?vue&type=template&id=376c64d2&scoped=true&"
import script from "./edit_transfer.vue?vue&type=script&lang=js&"
export * from "./edit_transfer.vue?vue&type=script&lang=js&"
import style0 from "./edit_transfer.vue?vue&type=style&index=0&id=376c64d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376c64d2",
  null
  
)

export default component.exports